import { createApp } from 'vue'
import App from './App.vue'
// import * as pdfjsLib from 'pdfjs-dist';

// pdfjsLib.GlobalWorkerOptions.workerSrc = `./js/pdf.worker.min.js`;

createApp(App).mount('#app')
